<!-- @format -->

<div class="flex footer">
  <div class="flex-auto flex flex-col justify-center items-center caption text-secondary">
    <!-- <div>{{ user?.Organization }}</div> -->
    <div>Copyright &copy; 2017-{{ year }} Heartbeat International</div>
    <i>All Rights Reserved</i>
  </div>
</div>
